'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarCheckLines, iconCalendarCheckLinesTag } from '@ni/nimble-components/dist/esm/icons/calendar-check-lines';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarCheckLines };
export { iconCalendarCheckLinesTag };
export const NimbleIconCalendarCheckLines = wrap(IconCalendarCheckLines);